import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import { SERVER_ORIGIN } from "../../utilities/constants";
import { hasReadOnlyAccess } from "../../utilities/helper_functions";
import HeaderCard from "../../components/common/HeaderCard";
import BackButton from "../../components/common/BackButton";
import "../../css/user/user-profile.css";
import css from "../../css/admin/user-single-page.module.css";

const RegionEMProfile = () => {
    const { _id } = useParams();
    const navigate = useNavigate();
    const isReadOnly = hasReadOnlyAccess();
    const [user, setUser] = useState({
        name: "",
        email: "",
        region: "",
        mobile_no: "",
        role: "",
        country: "",
        state: "",
        city: "",
    });

    useEffect(() => {
        const verifyToken = async () => {
            const response = await fetch(
                `${SERVER_ORIGIN}/api/regionem/auth/verify-token`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": sessionStorage.getItem("token"),
                    },
                }
            );
            const result = await response.json();
            if (!result) {
                toast.error("Please login to continue");
                navigate("/login?userType=regionem");
            }
        };

        verifyToken();
    }, [navigate]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setUser({
            ...user,
            [name]: value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (isReadOnly) {
            toast.error("You have read-only access and cannot modify profile data");
            return;
        }

        try {
            const response = await fetch(
                `${SERVER_ORIGIN}/api/regionem/auth/update-user/${_id}`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "auth-token": sessionStorage.getItem("token"),
                    },
                    body: JSON.stringify(user),
                }
            );
            const result = await response.json();
            if (result.userDoc) {
                toast.success(`Profile updated successfully`);
                navigate("/admin/services");
            } else {
                toast.error("Some error occurred, please try again later");
            }
        } catch (error) {
            console.error("Error updating profile:", error);
            toast.error("Some error occurred, please try again later");
        }
    };

    useEffect(() => {
        async function getUserData() {
            try {
                const response = await fetch(
                    `${SERVER_ORIGIN}/api/regionem/auth/${_id}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "auth-token": sessionStorage.getItem("token"),
                        },
                    }
                );

                const result = await response.json();
                if (response.status >= 400 && response.status < 600) {
                    if (response.status === 401) {
                        navigate("/login?userType=regionem");
                    } else if (response.status === 500) {
                        toast.error(result.statusText);
                    }
                } else if (response.ok && response.status === 200) {
                    setUser(result.user);
                }
            } catch (err) {
                console.error(err.message);
                toast.error("Error fetching profile data");
            }
        }

        if (_id) {
            getUserData();
        }
    }, [_id, navigate]);

    return (
      <div className="outerDiv">
        <HeaderCard>
          <BackButton text="Back to Dashboard" customPath="/admin/services" />
          <h1 className="headerTitle">My Profile - Regional Mentor</h1>
          <hr />
          {isReadOnly && (
            <div className="alert alert-info" role="alert">
              <strong>Note:</strong> You have read-only access. Profile
              information cannot be modified.
            </div>
          )}
        </HeaderCard>

        <form className="user-profile-form" onSubmit={handleSubmit}>
          <div className="user-profile-grid pb-5">
            <div className="user-profile-section">
              <label className="user-profile-label" htmlFor="name">
                Name <span style={{ color: "red" }}>*</span>{" "}
              </label>
              <input
                type="text"
                id="name"
                className="user-profile-input"
                name="name"
                value={user.name || ""}
                onChange={handleInputChange}
                readOnly={isReadOnly}
                required
              />
            </div>

            <div className="user-profile-section">
              <label className="user-profile-label" htmlFor="email">
                Email <span style={{ color: "red" }}>*</span>{" "}
              </label>
              <input
                type="email"
                id="email"
                className="user-profile-input"
                name="email"
                value={user.email || ""}
                onChange={handleInputChange}
                readOnly
              />
            </div>

            <div className="user-profile-section">
              <label className="user-profile-label" htmlFor="region">
                Region <span style={{ color: "red" }}>*</span>{" "}
              </label>
              <input
                type="text"
                id="region"
                className="user-profile-input"
                name="region"
                value={user.region || ""}
                onChange={handleInputChange}
                readOnly={isReadOnly}
                required
              />
            </div>

            <div className="user-profile-section">
              <label className="user-profile-label" htmlFor="mobile_no">
                Mobile Number <span style={{ color: "red" }}>*</span>{" "}
              </label>
              <input
                type="tel"
                id="mobile_no"
                className="user-profile-input"
                name="mobile_no"
                value={user.mobile_no || ""}
                onChange={handleInputChange}
                readOnly={isReadOnly}
                pattern="[0-9]{10}"
                maxLength="10"
                required
              />
            </div>

            <div className="user-profile-section">
              <label className="user-profile-label" htmlFor="role">
                Role
              </label>
              <input
                type="text"
                id="role"
                className="user-profile-input"
                name="role"
                value={user.role || "Regional Mentor"}
                onChange={handleInputChange}
                readOnly
              />
            </div>

            <div className="user-profile-section">
              <label className="user-profile-label" htmlFor="country">
                Country <span style={{ color: "red" }}>*</span>{" "}
              </label>
              <input
                type="text"
                id="country"
                className="user-profile-input"
                name="country"
                value={user.country || "India"}
                onChange={handleInputChange}
                readOnly={isReadOnly}
              />
            </div>

         
          </div>

          {!isReadOnly && (
            <div style={{ textAlign: "center", margin: "2rem" }}>
              <button className="user-profile-button" type="submit">
                Save Changes
              </button>
            </div>
          )}
        </form>
      </div>
    );
};

export default RegionEMProfile; 